import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action) => ({
      ...state,
      user: action.payload,
    }),
    setCurrentDashboardDetails: (state, action) => ({
      ...state,
      currentDashboardDetails: action.payload,
    }),
    setAllDashboardDetails: (state, action) => ({
      ...state,
      allDashboardDetails: action.payload,
    }),
    setCohortSelection: (state, action) => ({
      ...state,
      cohortSelection: action.payload,
    }),
    setCohortList: (state, action) => ({
      ...state,
      cohortList: action.payload,
    }),
  },
});

export const {
  setUser,
  setCurrentDashboardDetails,
  setAllDashboardDetails,
  setCohortSelection,
  setCohortList,
} = authSlice.actions;

export default authSlice.reducer;
